import type React from 'react';

interface UseDragAndDropProps {
    onFileSelect: (file: File) => void;
    multiple?: boolean;
}

interface DragAndDropHandlers {
    handleDrop: (e: React.DragEvent<HTMLDivElement>) => void;
    handleDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
}

export const useDragAndDrop = ({ onFileSelect, multiple = false }: UseDragAndDropProps): DragAndDropHandlers => {
    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        const droppedFiles = Array.from(e.dataTransfer.files);
        const filesToProcess = multiple ? droppedFiles : droppedFiles.slice(0, 1);

        for (const file of filesToProcess) {
            onFileSelect(file);
        }
    };

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    return {
        handleDrop,
        handleDragOver,
    };
};
